/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import uniq from 'lodash.uniq';
import {GenericObject} from '@ion/core/src/types/entities';

export const icnApps =  {
  'First Notice of Loss'       : '9fed2e7a-55bf-49e1-b316-626dc915507e',
  'Accident Reconstruction'    : '645e2ab6-e087-4303-98c9-eaf79dce3efa',
  'Predictive Physical Damage' : '031b47b9-0298-43d3-b2de-49221f085d74',
  'ICN+'                       : '3953a5b7-3009-410d-b4d5-b941aeca586f'
};

export const otherApps  = {
  'Tag Detection' : '7e554773-9889-43b2-8545-88fbc92f9025',
  'Video Service' : 'a91665df-eb9f-44dc-8538-e6d5527b1036'
};

export const SERVICES = {
  'First Notice of Loss'       : 'ICN',
  'Accident Reconstruction'    : 'ICN',
  'Predictive Physical Damage' : 'ICN',
  'ICN+'                       : 'ICN',
  'Tag Detection'              : 'BLE',
  'Video Service'              : 'IVT'
};

export const getAppKey = (application) => {
  const href = application?.href;
  return href.substring(href.lastIndexOf('/') + 1);
};

export const getServices = (applications) => {
  const icnAppsArr = Object.values(icnApps);
  const otherAppsArr = Object.values(otherApps);
  const filteredApplications = applications?.filter((item) => {
    const appKey = getAppKey(item); ;
    return (icnAppsArr.indexOf(appKey) > -1 || otherAppsArr.indexOf(appKey) > -1 || item.title.includes('Sensor'));
  });
  const services = [];
  if (filteredApplications?.length) {
    filteredApplications?.map((item) => {
      const appName = SERVICES[item.title] ? SERVICES[item.title] : item.title;
      if (appName) {
        services.push(appName?.toString());
      }
    });
  }
  return uniq(services);
};

export const enableManageServices = (applications) => {
  const icnAppsArr = Object.values(icnApps);
  const otherAppsArr = Object.values(otherApps);
  const appArr = applications?.filter((item) => {
    const appKey = getAppKey(item);
    return (icnAppsArr.indexOf(appKey) > -1 || otherAppsArr.indexOf(appKey) > -1);
  });
  return (appArr?.length > 0);
};

export const validateServices = (serviceInfo: GenericObject[]) => {
  let isError = true;
  const tempService = serviceInfo?.map((item) => {
    const serviceName = item?.service?.name;
    if (!serviceName) {
      item.service.error = true;
      isError = false;
    } else {
      item.service.error = false;
    }
    return item;
  });
  return {
    isValid     : isError,
    serviceData : tempService
  };
};
